/**
 * SÉCURITÉ: Logger personnalisé qui désactive les logs en production
 *
 * Empêche la fuite d'informations sensibles via les logs console en production.
 * Utilise process.env.NODE_ENV pour détecter l'environnement.
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Logger sécurisé qui ne log qu'en développement
 */
const logger = {
  /**
   * Log d'information (équivalent à console.log)
   * @param {...any} args - Arguments à logger
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Log d'erreur (équivalent à console.error)
   * Toujours actif car les erreurs doivent être visibles même en production
   * MAIS masque les données sensibles
   * @param {...any} args - Arguments à logger
   */
  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    } else {
      // En production, logger uniquement le message d'erreur sans détails sensibles
      console.error('Une erreur s\'est produite. Consultez les logs serveur pour plus de détails.');
    }
  },

  /**
   * Log d'avertissement (équivalent à console.warn)
   * @param {...any} args - Arguments à logger
   */
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Log d'information (équivalent à console.info)
   * @param {...any} args - Arguments à logger
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  /**
   * Log de debug (équivalent à console.debug)
   * @param {...any} args - Arguments à logger
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  /**
   * Log de table (équivalent à console.table)
   * @param {any} data - Données à afficher en tableau
   */
  table: (data) => {
    if (isDevelopment) {
      console.table(data);
    }
  }
};

export default logger;
